export type SkyStar = {
  id: string;
  name: string;
  constellation: string;
  ra: number;
  dec: number;
  mag: number;
};

export type ConstellationLine = {
  id: string;
  name: string;
  stars: string[];
};

export const skyStars: SkyStar[] = [
  { id: "regulus", name: "Regulus", constellation: "Leo", ra: 10.1395, dec: 11.9672, mag: 1.35 },
  { id: "algieba", name: "Algieba", constellation: "Leo", ra: 10.3328, dec: 19.8415, mag: 2.01 },
  { id: "zosma", name: "Zosma", constellation: "Leo", ra: 11.2351, dec: 20.5237, mag: 2.56 },
  { id: "denebola", name: "Denebola", constellation: "Leo", ra: 11.8177, dec: 14.5721, mag: 2.14 },
  { id: "chertan", name: "Chertan", constellation: "Leo", ra: 11.2373, dec: 15.4296, mag: 3.33 },
  { id: "spica", name: "Spica", constellation: "Virgo", ra: 13.4199, dec: -11.1613, mag: 0.98 },
  { id: "porrima", name: "Porrima", constellation: "Virgo", ra: 12.6943, dec: -1.4494, mag: 2.74 },
  { id: "vindemiatrix", name: "Vindemiatrix", constellation: "Virgo", ra: 13.0363, dec: 10.9591, mag: 2.85 },
  { id: "arcturus", name: "Arcturus", constellation: "Bootes", ra: 14.261, dec: 19.1824, mag: -0.05 },
  { id: "izar", name: "Izar", constellation: "Bootes", ra: 14.7498, dec: 27.0742, mag: 2.35 },
  { id: "muphrid", name: "Muphrid", constellation: "Bootes", ra: 13.9114, dec: 18.3977, mag: 2.68 },
  { id: "antares", name: "Antares", constellation: "Scorpius", ra: 16.4901, dec: -26.432, mag: 1.06 },
  { id: "dschubba", name: "Dschubba", constellation: "Scorpius", ra: 16.0056, dec: -22.6217, mag: 2.29 },
  { id: "acrab", name: "Acrab", constellation: "Scorpius", ra: 16.0906, dec: -19.8055, mag: 2.62 },
  { id: "shaula", name: "Shaula", constellation: "Scorpius", ra: 17.5601, dec: -37.1038, mag: 1.62 },
  { id: "sargas", name: "Sargas", constellation: "Scorpius", ra: 17.6219, dec: -42.9978, mag: 1.86 },
  { id: "kaus-australis", name: "Kaus Australis", constellation: "Sagittarius", ra: 18.4029, dec: -34.3846, mag: 1.79 },
  { id: "nunki", name: "Nunki", constellation: "Sagittarius", ra: 18.9211, dec: -26.2967, mag: 2.05 },
  { id: "vega", name: "Vega", constellation: "Lyra", ra: 18.6156, dec: 38.7837, mag: 0.03 },
  { id: "altair", name: "Altair", constellation: "Aquila", ra: 19.8464, dec: 8.8683, mag: 0.76 },
  { id: "deneb", name: "Deneb", constellation: "Cygnus", ra: 20.6905, dec: 45.2803, mag: 1.25 },
  { id: "procyon", name: "Procyon", constellation: "Canis Minor", ra: 7.655, dec: 5.225, mag: 0.4 },
  { id: "sirius", name: "Sirius", constellation: "Canis Major", ra: 6.7525, dec: -16.7161, mag: -1.46 }
];

export const constellationLines: ConstellationLine[] = [
  { id: "leo", name: "Leo", stars: ["regulus", "algieba", "zosma", "denebola", "chertan", "regulus"] },
  { id: "virgo", name: "Virgo", stars: ["vindemiatrix", "porrima", "spica"] },
  { id: "bootes", name: "Bootes", stars: ["muphrid", "arcturus", "izar"] },
  { id: "scorpius", name: "Scorpius", stars: ["acrab", "dschubba", "antares", "shaula", "sargas"] },
  { id: "sagittarius", name: "Sagittarius", stars: ["kaus-australis", "nunki"] },
  { id: "summer-triangle", name: "Summer Triangle", stars: ["vega", "deneb", "altair", "vega"] }
];
